export const getEventRegistrationDrawerPaperProps = (embeddedPreview = false) => ({
    sx: {
        width: embeddedPreview ? '100%' : { xs: '100vw', sm: 500 },
        maxWidth: embeddedPreview ? '100%' : '100vw',
        height: embeddedPreview ? '100%' : { xs: '100dvh', sm: '100%' },
        maxHeight: embeddedPreview ? '100%' : '100dvh',
        borderTopLeftRadius: embeddedPreview ? 0 : { xs: 0, sm: '24px' },
        borderBottomLeftRadius: embeddedPreview ? 0 : { xs: 0, sm: '24px' },
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        overflow: 'hidden',
        boxShadow: 3,
        backgroundColor: '#FFFFFF',
        backdropFilter: 'none',
        WebkitBackdropFilter: 'none',
        '&.MuiDrawer-paperAnchorRight, &.MuiDrawer-paperAnchorLeft': {
            backgroundColor: '#FFFFFF',
            backdropFilter: 'none',
            WebkitBackdropFilter: 'none'
        }
    }
});
export const eventRegistrationDrawerPaperProps = getEventRegistrationDrawerPaperProps();
export const getEventRegistrationDrawerContentHeight = (embeddedPreview = false) => embeddedPreview ? 'calc(100% - 72px)' : { xs: 'calc(100dvh - 72px)', sm: 'calc(100svh - 25px)' };
export const eventRegistrationDrawerSlideProps = {
    timeout: 400,
    easing: {
        enter: 'cubic-bezier(0.4, 0, 0.2, 1)',
        exit: 'cubic-bezier(0.4, 0, 0.2, 1)'
    }
};
export const eventRegistrationDrawerCloseButtonSx = {
    width: { xs: 48, sm: 48, md: 64 },
    height: { xs: 40, sm: 40, md: 48 },
    border: '1px solid #00244D99',
    color: '#00244D',
    borderRadius: { xs: 1, sm: 1, md: 2 }
};
